<feature-pm-select-card />
<feature-pm-celebrations-card />

<div class="container">
	<div class="search-input" [ngClass]="{ 'dropdown-open': hasFilteredCities$ | async }">
		<input type="text" placeholder="Digite sua cidade" [formControl]="searchControl" #searchInput />
		@if (!selectedCity) {
			<mat-icon
				class="icon"
				svgIcon="pm-icons:search"
				style="
					width: 29px;
					height: 29px;
					cursor: pointer;
					background-color: var(--content-primary);
					border-radius: 100px;
					padding: 6px;
					--icon-color-red: #fff;
				"
				(click)="searchInput.focus()"
			></mat-icon>
		} @else {
			<mat-icon
				class="icon"
				svgIcon="pm-icons:close"
				style="
					width: 29px;
					height: 29px;
					cursor: pointer;
					background-color: var(--content-primary);
					border-radius: 100px;
					padding: 6px;
					--icon-color-red: #fff;
				"
				(click)="clearFilter()"
			></mat-icon>
		}

		<ul
			*ngIf="filteredCities$ | async as cities"
			class="dropdown"
			[style.display]="cities.length ? 'block' : 'none'"
		>
			<li *ngFor="let city of cities" class="dropdown-item" (click)="onSelectCity(city)">
				{{ city.nome }}, {{ ufCodeMap[city.codigo_uf] || city.codigo_uf }}
			</li>
			<li *ngIf="cities.length === 0" class="dropdown-item no-result">Nenhuma cidade encontrada</li>
		</ul>
	</div>

	<div *ngIf="selectedCity">
		<ng-container *ngIf="statusVenues$ | async as status">
			@if (status === 'pending' || status === 'idle') {
				<ui-pm-loading-page />
			} @else {
				<ng-container *ngIf="venues$ | async as venues">
					<div *ngIf="venues.length > 0; else noResult" class="card-list">
						<ui-pm-venue-card
							*ngFor="let venue of venues"
							[venue]="venue"
							[client]="client | async"
						/>
					</div>

					<ng-template #noResult>
						<div
							style="
								display: flex;
								flex-direction: column;
								align-items: center;
								text-align: center;
								color: var(--content-txt);
								margin: 20px 0;
							"
						>
							<mat-icon
								svgIcon="pm-icons:close-circle"
								style="margin-bottom: 14px; width: 32px; height: 32px"
							></mat-icon>
							<p style="font-size: 16px; font-weight: 600">
								Nenhum restaurante encontrado no raio de até 50 km da sua cidade.
							</p>
							<p>Verifique como obter seu presente</p>

							<button
								mat-raised-button
								style="margin-top: 40px; max-width: 425px"
								[routerLink]="['/escolha-cesta-celebrations']"
							>
								Resgatar presente
							</button>
						</div>
					</ng-template>
				</ng-container>
			}
		</ng-container>
	</div>
</div>
